import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../translations/translations';
import { MailIcon } from './ui/icons';

const Footer = () => {
  const { language } = useLanguage();

  return (
    <footer className="bg-dark-lighter border-t border-dark-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 text-left">
            {/* Historio Section */}
            <div className="space-y-4">
              <h3 className="text-xl font-serif text-gradient-bronze font-bold mb-4">
                Historio
              </h3>
              <p className="text-light-secondary text-sm leading-relaxed">
                {t('footerDescription', language)}
              </p>

              {/* Contact Info */}
              <div className="pt-4">
                <h4 className="text-base font-medium text-light mb-3">
                  {t('contactInfo', language)}
                </h4>
                <div className="flex items-start gap-2 text-light-secondary text-sm">
                  <MailIcon className="w-4 h-4 text-bronze shrink-0 mt-0.5" />
                  <a
                    href="mailto:historio.info@gmail.com"
                    className="hover:text-bronze transition-colors break-all"
                  >
                    historio.info@gmail.com
                  </a>
                </div>
              </div>
            </div>

            {/* Quick Links Section */}
            <div>
              <h3 className="text-xl font-serif text-light font-semibold mb-4">
                {t('quickLinks', language)}
              </h3>
              <div className="flex flex-col space-y-2">
                <Link
                  to="/"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('home', language)}
                </Link>
                <Link
                  to="/shop"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('shop', language)}
                </Link>
                <Link
                  to="/blog"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('blog', language)}
                </Link>
                <Link
                  to="/contact"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('contact', language)}
                </Link>
                <Link
                  to="/privacy-policy#cookies"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('cookies', language)}
                </Link>
              </div>
            </div>

            {/* Categories Section */}
            <div>
              <h3 className="text-xl font-serif text-light font-semibold mb-4">
                {t('categories', language)}
              </h3>
              <div className="flex flex-col space-y-2">
                <Link
                  to="/blog?category=On Today's Day"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('onTodaysDay', language)}
                </Link>
                <Link
                  to="/blog?category=Battles"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('battles', language)}
                </Link>
                <Link
                  to="/blog?category=Castles"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('castles', language)}
                </Link>
                <Link
                  to="/blog?category=Myths"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('myths', language)}
                </Link>
                <Link
                  to="/blog?category=War Machines"
                  className="text-light-secondary hover:text-bronze transition-colors text-sm"
                >
                  {t('warMachines', language)}
                </Link>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="mt-8 pt-8 border-t border-dark-border">
            <p className="text-center text-light-muted text-sm">
              &copy; {new Date().getFullYear()} Historio. {t('allRightsReserved', language)}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
